import cntl from "cntl";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { Footer, FooterContent } from "../atoms";
import FooterBottom from "../atoms/FooterBottom";
import { FOOTER_COLOR_VARIANTS, POSITIONS } from "../constants";

const propTypes = {
  columns: PropTypes.array,
  sideObject: PropTypes.object,
  theme: PropTypes.oneOf([FOOTER_COLOR_VARIANTS]),
  objectPosition: PropTypes.oneOf([POSITIONS.left, POSITIONS.right]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

function FooterColumns({
  theme,
  columns,
  children,
  sideObject,
  objectPosition,
}) {
  const [color, setColor] = useState("");
  const [headerColor, setHeaderColor] = useState("");

  const footerCn = () => cntl`
    flex 
    px-4
    py-12
    w-full
    flex-col 
    divide-y
    lg:pt-16
    lg:pb-12
    lg:px-20
    gap-y-12
    lg:gap-y-16
    justify-center
    ${color}
  `;

  useMemo(() => {
    switch (theme) {
      case FOOTER_COLOR_VARIANTS.primary:
        setHeaderColor("text-primary-400");
        setColor("bg-primary-800 text-primary-200 divide-primary-600");
        break;
      case FOOTER_COLOR_VARIANTS.grey:
        setHeaderColor("text-grey-400");
        setColor("bg-grey-50 text-grey-600 divide-grey-200 divide-grey-200");
        break;
      case FOOTER_COLOR_VARIANTS.dark:
        setHeaderColor("text-grey-400");
        setColor("bg-grey-800 text-grey-200 divide-grey-600 divide-grey-600");
        break;
      default:
        setHeaderColor("text-grey-400");
        setColor("bg-white text-grey-600 divide-grey-200 divide-grey-200");
        break;
    }
  }, [theme]);

  return (
    <Footer className={footerCn()}>
      <FooterContent
        theme={theme}
        columns={columns}
        sideObject={sideObject}
        headerColor={headerColor}
        objectPosition={objectPosition}
      />
      <FooterBottom>{children}</FooterBottom>
    </Footer>
  );
}

FooterColumns.propTypes = propTypes;
export default FooterColumns;
